export default {
      id: "i-service-dividents-min-usage",
      viewBox: "0 0 70 70",
      url: __webpack_public_path__ + "img/sprite.svg#i-service-dividents-min",
      toString: function () {
        return this.url;
      }
    }